<template>
  <div id="reminder-detail" class="data-list-container text-sm">
    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
      <h4 class="font-bold">Remind Offer Detail</h4>
      <router-link :to="'/reminder'"><vs-button color="danger" type="border" class="py-2" style="background: #fff !important;">Close</vs-button></router-link>
    </div>
    <!-- <hr style="margin-top:20px;"> -->
    <!-- <vs-divider></vs-divider> -->
    <div class="mt-6">
      <vs-row style="min-height: calc(100vh - 15rem);">
        <vs-col vs-w="3" class="bg-white rounded-item shadow-md" style="padding-bottom: 50px">
          <div class="px-6">
            <div class="mt-5 mb-4" style="color:cornflowerblue"> Everyone </div>
            <vs-row class="flex align-center">
                  <p class="product-name font-medium truncate p-0">{{ this.remindersList.name }}</p>
                  <!-- <vx-tooltip :text="this.remindersList.remind_campaign.content" position="right">
                     <feather-icon icon="HelpCircleIcon" svgClasses="w-5 stroke-current ml-2" />
                  </vx-tooltip> -->
                  <button class="tooltip border-0 cursor-pointer" style="background: none;" @click.stop>
                    <feather-icon icon="HelpCircleIcon" svgClasses="w-5 stroke-current ml-2" />
                    <span class="tooltiptext break-word">
                      {{this.remindersList.remind_campaign.content}}
                    </span>
                  </button>
                </vs-row>
            <div class="flex align-center font-bold text-xl py-3">
                DISCOUNT:
                <div v-if="this.remindersList.logic_type=='percent'">
                  <span class="product-name font-bold truncate ml-2">{{ this.remindersList.logic_value }}%</span>
                </div>
                <div v-else-if="this.remindersList.logic_type=='usd'">
                  <span class="product-name font-bold truncate ml-2">{{ this.remindersList.logic_value }}$</span>
                </div>
                <div v-else>
                  <span class="product-name font-bold truncate ml-2">N/A</span>
                </div>
            </div>
              <vs-row class="flex align-center mt-2 mb-6">
                <feather-icon icon="CalendarIcon" svgClasses='h-4 w-4 mb-1 mr-2'></feather-icon>
                <p class="product-name font-medium">
                  No visit after {{ this.remindersList.remind_campaign.after_date}} days</p>
              </vs-row>
            </div>

            <vs-divider class="px-4"></vs-divider>
            <div class="px-6">
              <span class="cate-name pt-2 custom-font-size-title mb-0">TOTAL DELIVERED</span>
              <div class="flex align-end flex-wrap">
                <span class="text-2xl mr-6 mt-3" style="line-height: 0.7">{{this.remindersList.campaign_report.total_receive_message}}</span>
                <!-- <span> -->
                <div class="flex align-end mt-3">
                  <feather-icon icon="SmartphoneIcon" svgClasses='w-4 h-4 mr-2'></feather-icon>
                  <span class="mr-6" style="line-height: 1">{{this.remindersList.campaign_report.total_sms_sent}}</span>
                </div>
                <!-- </span> -->
                <div class="flex align-end mt-3">
                  <feather-icon icon="MailIcon" svgClasses='w-4 h-4 mr-2'></feather-icon>
                  <span style="line-height: 1">{{this.remindersList.campaign_report.total_email_sent}}</span>
                </div>
              </div>

              <span class="cate-name pt-6 pb-3 custom-font-size-title">REDEMPTION</span>
              <span class="text-2xl mr-6" style="line-height: 0.7">{{this.remindersList.campaign_report.total_redemption}}</span>
            </div>

            <vs-divider class="px-4"></vs-divider>
            <vs-row class="px-6">
              <vs-col vs-w="6" class="text-center">
                <span class="cate-name py-2 custom-font-size-title">INCOME</span>
                <span class="text-2xl" style="line-height: 0.7">${{this.remindersList.campaign_report.total_income}}</span>
              </vs-col>

              <vs-col vs-w="6" class="text-center">
                <span class="cate-name py-2 custom-font-size-title">EXPENSE</span>
                <span class="text-2xl" style="line-height: 0.7">${{this.remindersList.campaign_report.total_expense }}</span>
              </vs-col>
            </vs-row>
        </vs-col>
        <vs-col vs-w="9" class="pl-5">
          <vs-table ref="table" :max-items="itemsPerPage" :data="campaignHistoryList.items">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
              <div class="con-input-search vs-table--search p-0">
                <input
                  type="text"
                  class="input-search vs-table--search-input rounded-item"
                  placeholder="Name, phone"
                  @keyup="searchItem"
                  v-model="search"
                />
                <i class="vs-icon notranslate icon-scale material-icons null">search</i>
              </div>
            </div>
            <template slot="thead">
              <vs-th class="center-title text-center">#</vs-th>
              <vs-th class="center-title text-center">Name</vs-th>
              <vs-th class="center-title text-center">Phone</vs-th>
              <vs-th class="center-title text-center">Visit</vs-th>
              <vs-th class="center-title text-center">Income</vs-th>
              <vs-th class="center-title text-center">Created At</vs-th>
              <vs-th class="center-title text-center">Used Total</vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody id="promotion-history-list" class="vs-con-loading__container">
                <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
                  <vs-td class="text-center">{{indextr + 1}}</vs-td>
                  <vs-td class="text-center">{{tr.customer.full_name}}</vs-td>
                  <vs-td class="text-center">{{StringHelper.phoneNumberFormat(tr.customer.phone)}}</vs-td>
                  <vs-td class="text-center">{{tr.customer.visit_count}}</vs-td>
                  <vs-td class="text-center">0</vs-td>
                  <vs-td class="text-center">{{changeFormat(tr.created_at)}}</vs-td>
                  <vs-td class="text-center">{{tr.total_used}}</vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
          
          <div v-if="campaignHistoryList && campaignHistoryList._meta.pageCount > 1">
            <custom-pagination class="custom-pagination" :totalPages="parseInt(campaignHistoryList._meta.pageCount)" :currentPage="currentPage" @pageChanged="changePage" :key="page_key"
          ></custom-pagination>
          </div>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import {changeFormatHelper} from '../../helper/datetimeHelper';
import { StringHelper } from "../../models/string_helper";
export default {
  data(){
    return {
      currentPage: 1,
      itemsPerPage: 5,
      page_key: 0,
      search: '',
      StringHelper,
      isOpenLoading: false,
      action_type: '',
      loaded_data_num: 0
    }
  },
  components: {
    moment
  },
  computed:{
    remindersList(){
      return this.$store.state.promoList.reminderInfo;
    },
    campaignHistoryList() {
      return this.$store.getters['promoList/campaignHistoryList'];
    }
  },
  watch: {
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 2) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    }
  },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' campaign history failed',
            acceptText: 'OK'
          })
        }
      }, 10000);

    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    groups(tr){
      // let arr = tr.split(',');
      let temp = [];
      for(let i=0;i<this.groupsList.length;i++){
          if(tr == this.groupsList[i].id){
              if(temp.length > 0) {
                temp.push(',')
              }
              temp.push(this.groupsList[i].name)
          }

      }
      for(let j=0;j<temp.length;j++){
        return temp[j]
      }
    },
    changeFormat(date){
      if(date) {
        return changeFormatHelper(date);
      } else {
        return 'N/A';
      }
    },
    changePage(page) {
      let data = {
        id: this.$route.query.id,
        page: page,
        'per-page': this.itemsPerPage,
        keyword: this.search
      }
      this.action_type = "Get list";
      this.openLoadingInDiv();
      this.$store.dispatch('promoList/GET_CAMPAIGN_HISTORY_LIST', data).then(() => {
        this.currentPage = page;
        this.closeLoading();
      })
    },
    searchItem({target}) {
      this.currentPage = 1;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.action_type = 'Search';
      if(!this.isOpenLoading){
        this.openLoadingInDiv();
      }
      this.timer = setTimeout(() => {
        this.search = target.value;
        const data = {
          id: this.$route.query.id,
          page: this.currentPage,
          "per-page": this.itemsPerPage,
          keyword: target.value
        };
        this.$store.dispatch('promoList/GET_CAMPAIGN_HISTORY_LIST', data).then(() => {
          this.closeLoading();
        });
      }, 500);
    }
  },
  created(){
    const obj = {
      id: this.$route.query.id,
    }
    this.$store.dispatch("promoList/GET_REMINDER_DETAIL",obj).then(() => {
      this.loaded_data_num++;
    })

    let data = {
      id: this.$route.query.id,
      page: this.currentPage,
      'per-page': this.itemsPerPage,
      keyword: this.search
    }

    this.$store.dispatch("promoList/GET_CAMPAIGN_HISTORY_LIST", data).then(() => {
      this.loaded_data_num++;
    });
  }
}
</script>